import './SalesforceSetupPanel.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { SalesforceOrganizationSyncConfigurationButton } from './SalesforceOrganizationSyncConfigurationButton';
import { SalesforceOrganizationSyncControls } from './SalesforceOrganizationSyncControls';
import { SalesforceOrganizationTypeTag } from './SalesforceOrganizationTypeTag';
import { SalesforceOrgSyncSecurityAlertsControls } from './SalesforceOrgSyncSecurityAlertsControls';
import { SonarTable } from '@ui/SonarTable';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useCallback, useEffect, useState } from 'react';
import { useAction, useInterval, useOnMount, useSonarSelector } from '@hooks';
const getAllSalesforceOrganizationsSelectors = createAsyncSelectors((state) => state.core.organizations.salesforce.all.get);
const salesforceSetupTableColumns = [
    {
        dataIndex: 'name',
        key: 'name',
        title: ADMIN_DASHBOARD_COPY.ORGANZATION_NAME,
        width: 300
    },
    {
        dataIndex: 'isSandbox',
        key: 'sandbox',
        render: (isSandbox) => React.createElement(SalesforceOrganizationTypeTag, { isSandbox: isSandbox }),
        title: ADMIN_DASHBOARD_COPY.IS_SANDBOX,
        width: 100
    },
    {
        dataIndex: 'instanceUrl',
        key: 'instanceUrl',
        render: (instanceUrl) => React.createElement("a", { href: instanceUrl }, instanceUrl),
        title: ADMIN_DASHBOARD_COPY.INSTANCE_URL,
        width: 300
    },
    {
        dataIndex: 'salesforceUsername',
        key: 'salesforceUsername',
        title: ADMIN_DASHBOARD_COPY.SALESFORCE_USERNAME,
        width: 300
    },
    {
        dataIndex: 'id',
        key: 'id',
        title: ADMIN_DASHBOARD_COPY.ID,
        width: 75
    },
    {
        align: 'center',
        key: 'importConfig',
        render: (organization) => React.createElement(SalesforceOrganizationSyncConfigurationButton, { organizationId: organization === null || organization === void 0 ? void 0 : organization.id, organizationName: organization === null || organization === void 0 ? void 0 : organization.name, shardName: organization.shardName }),
        width: 100
    },
    {
        dataIndex: 'latestIndexTime',
        key: 'lastSync',
        render: (latestIndexTime, organization) => React.createElement(SalesforceOrganizationSyncControls, { organization: organization, shardName: organization.shardName }),
        title: ADMIN_DASHBOARD_COPY.LAST_SYNC,
        width: 600
    },
    {
        key: 'syncSecurityAlerts',
        render: (organization) => React.createElement(SalesforceOrgSyncSecurityAlertsControls, { organization: organization }),
        title: ADMIN_DASHBOARD_COPY.SYNC_SECURITY_ALERTS,
        width: 100
    }
];
export const SalesforceSetupPanel = (props) => {
    const { id, searchDetails } = props;
    const allSalesforceOrganizations = useSonarSelector(getAllSalesforceOrganizationsSelectors.data);
    const [allSalesforceOrganizationsWithShards, setAllSalesforceOrganizationsWithShards] = useState([]);
    const getAllSalesforceOrganizations = useAction(coreActions.requestGetCoreAllSalesforceOrganizationsByCustomer);
    const refreshOrganizations = useCallback(() => {
        if (searchDetails) {
            const { customerId, shardName } = searchDetails;
            getAllSalesforceOrganizations({
                customerId,
                shardName
            });
        }
    }, [searchDetails, getAllSalesforceOrganizations]);
    useEffect(() => {
        if (searchDetails) {
            const orgsWithShardNames = [];
            if (allSalesforceOrganizations) {
                const { shardName } = searchDetails;
                allSalesforceOrganizations.organizations.forEach((element) => {
                    orgsWithShardNames.push(Object.assign({ shardName }, element));
                });
            }
            setAllSalesforceOrganizationsWithShards(orgsWithShardNames);
        }
    }, [allSalesforceOrganizations, searchDetails]);
    useOnMount(() => {
        refreshOrganizations();
    });
    useInterval(refreshOrganizations, 5000);
    return (React.createElement(SonarTable, { columns: salesforceSetupTableColumns, dataSource: allSalesforceOrganizationsWithShards, id: id, pagination: false, rowKey: 'id', scroll: { x: 'max-content' } }));
};
